import { useContext, useEffect, useRef } from "react";
import { GlobalContext } from "../Context/GlobalContext";
import useContacts from "../services/chat/useContacts";

const GlobalDataLoader = () => {
  const {
    userID,
    chatContactsFetched,
    audienceFetched,
  } = useContext(GlobalContext);

  const contactsHook = useContacts();

const {
  fetchChatContacts,
  fetchAudience,
} = contactsHook;

  // const {
  //   fetchChatContacts,
  //   fetchAudience,
  // } = useContacts();

  const loadingRef = useRef(false);

  useEffect(() => {
    if (!userID) return;

    const chatCacheKey = `chat_contacts_${userID}`;
    const audienceCacheKey = `audience_groups_${userID}`;

    const hasChatCache =
      sessionStorage.getItem(chatCacheKey) !== null;

    const hasAudienceCache =
      sessionStorage.getItem(audienceCacheKey) !== null;

    const shouldFetchChat =
      !chatContactsFetched && !hasChatCache;

    const shouldFetchAudience =
      !audienceFetched && !hasAudienceCache;

    if (!shouldFetchChat && !shouldFetchAudience) {
      return;
    }

    if (loadingRef.current) {
      return;
    }

    loadingRef.current = true;

    const loadGlobalData = async () => {
      try {
        await Promise.all([
          shouldFetchChat
            ? fetchChatContacts(1, 50)
            : Promise.resolve(),

          shouldFetchAudience
            ? fetchAudience()
            : Promise.resolve(),
        ]);
      } catch (error) {
        console.error(
          "Global data loading error:",
          error,
        );
      } finally {
        loadingRef.current = false;
      }
    };

    loadGlobalData();
  }, [
    userID,
    chatContactsFetched,
    audienceFetched,
  ]);

  return null;
};

export default GlobalDataLoader;